import { BANK_FIELD_CLASSES, type InputProps } from "./Input.js";
import { classes } from "./classes.js";
import { BANK_BAD_BORDER, BANK_BORDER_STRONG } from "./tokens.js";

/** `F-0b`: `Input`'s sibling for a paragraph (prototype `.textarea`): 96 px minimum, line height 1,5. */
export type TextareaProps = Pick<
  InputProps,
  | "id"
  | "value"
  | "onChange"
  | "placeholder"
  | "invalid"
  | "describedBy"
  | "readOnly"
  | "required"
  | "className"
  | "testId"
> & { readonly rows?: number };

export function Textarea(props: TextareaProps): React.JSX.Element {
  const { id, value, onChange, invalid, className } = props;
  return (
    <textarea
      id={id}
      value={value}
      onChange={(event) => onChange?.(event.target.value)}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      required={props.required}
      rows={props.rows}
      aria-invalid={invalid === true ? true : undefined}
      aria-describedby={props.describedBy}
      data-kit="textarea"
      data-testid={props.testId}
      className={classes(
        BANK_FIELD_CLASSES,
        "min-h-[96px] py-2 leading-normal",
        invalid === true ? BANK_BAD_BORDER : BANK_BORDER_STRONG,
        className,
      )}
    />
  );
}
